import Grid from "@mui/material/Grid";
import { Box, Stack } from "@mui/material";
import { LabelTemplate } from "./styles/table";
import { Employee } from "../types/processTypes";

import { BasicPostAppliedSingleValue } from "./components/basic/BasicPostApplied";
import { BasicDetail } from "./components/basic/BasicDetail";
import { BasicLanguageDetail } from "./components/basic/BasicLanguage";
import { BasicExperience } from "./components/basic/BasicExperience";
import { BasicSkillsTwoRows } from "./components/basic/BasicSkills";
import { BasicPassport } from "./components/basic/BasicPassport";
import { BasicFullName } from "./components/basic/BasicFullName";
import { BasicFace } from "./components/basic/BasicFace";
import { BasicStand } from "./components/basic/BasicStand";
import { BasicRemarksVer } from "./components/basic/BasicRemarks";
import { BasicReference } from "./components/basic/BasicReference";
import { BasicPassportScan } from "./components/basic/BasicPassportScan";
import { BasicHeader } from "./components/basic/BasicHeader";
import { Company } from "../../setups/types/setupTypes";

interface Props {
  selectedCompany: Company;
  currentEmployee: Employee;
  backgroundColor: string;
  cvTemplate: LabelTemplate;
}
function BasicTwoTemplate({
  selectedCompany,
  currentEmployee,
  backgroundColor,
  cvTemplate,
}: Props) {
  //a08745;f2f1f0 fffcf2
  return (
    <>
      <Box id="personalData" sx={{ p: 1 }}>
        <Grid
          container
          spacing={cvTemplate.spacing}
          sx={{
            p: 1,
            backgroundColor: backgroundColor,
          }}
        >
          <Grid
            item
            xs={12}
            sx={{
              height: "90%",
              mb: 1,
            }}
          >
            {cvTemplate && currentEmployee && (
              <BasicHeader
                selectedCompany={selectedCompany}
                currentEmployee={currentEmployee}
                template={cvTemplate}
              />
            )}
          </Grid>
          <Grid
            container
            item
            xs={12}
            spacing={cvTemplate.spacing}
            justifyContent="center"
            alignItems="center"
          >
            {/* Short Photo */}
            <Grid item xs={3}>
              {cvTemplate && currentEmployee && (
                <BasicFace
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                />
              )}
            </Grid>

            <Grid container item xs={9}>
              <Stack spacing={cvTemplate.spacing} sx={{ width: "100%" }}>
                {/* <BasicTitleSingleLang template={cvTemplate} /> */}
                <BasicReference
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                />
                {cvTemplate && currentEmployee && (
                  <BasicPostAppliedSingleValue
                    currentEmployee={currentEmployee}
                    template={cvTemplate}
                    showHeader={false}
                    showProfession={true}
                    showSalary={true}
                    showContractPeriod={true}
                  />
                )}
                {cvTemplate && currentEmployee && (
                  <BasicFullName
                    currentEmployee={currentEmployee}
                    template={cvTemplate}
                  />
                )}
              </Stack>
            </Grid>
          </Grid>

          <Grid item md={7} xs={12}>
            {cvTemplate && currentEmployee && (
              <>
                <BasicDetail
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                  showHeader={true}
                  showReference={false}
                  showNationality={true}
                  showPassportNumber={false}
                  showReligion={true}
                  showDateOfBirth={true}
                  showAge={true}
                  showPlaceOfBirth={true}
                  showMaritalStatus={true}
                  showNumberOfChildren={true}
                  showWeightHeight={true}
                  showComplexion={false}
                  showEducation={true}
                  showLivingTown={false}
                  showEmployeeTelephone={false}
                  showContactName={false}
                  showContactTelephone={false}
                />

                <BasicLanguageDetail
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                  showEducation={false}
                />

                <BasicExperience
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                  type="basic"
                />

                <BasicSkillsTwoRows
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                />
              </>
            )}
          </Grid>
          <Grid item md={5} xs={12}>
            {cvTemplate && currentEmployee && (
              <Stack
                spacing={cvTemplate.spacing}
                sx={{
                  alignItems: "center",
                }}
              >
                <BasicPassport
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                  showHeader={true}
                  showPassportNumber={true}
                  showIssueDate={true}
                  showPlaceOfIssue={true}
                  showExpiryDate={true}
                />

                <BasicStand
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                />

                <BasicRemarksVer
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                />
              </Stack>
            )}
          </Grid>
        </Grid>
      </Box>
      <Stack
        id="passportData"
        sx={{
          p: 1,
          pt: 1,
          backgroundColor: backgroundColor,
          minHeight: "1500px",
        }}
      >
        {cvTemplate.addPassportHeader && (
          <Box
            sx={{
              height: "90%",
            }}
          >
            {cvTemplate && currentEmployee && (
              <BasicHeader
                selectedCompany={selectedCompany}
                currentEmployee={currentEmployee}
                template={cvTemplate}
              />
            )}
          </Box>
        )}
        {cvTemplate && currentEmployee && (
          <Box
            sx={{
              mt: 15,
            }}
          >
            <BasicPassportScan
              currentEmployee={currentEmployee}
              template={cvTemplate}
            />
          </Box>
        )}
      </Stack>
    </>
  );
}

export default BasicTwoTemplate;
